var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 14",
    style: {
      enableBackground: "new 0 0 12 14"
    },
    xmlSpace: "preserve",
    width: 12,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    fill: "#FFFFFF"
  }, "\t.st0{clip-path:url(#SVGID_00000029749381743951083310000011202491988606364328_);}\t.st1{fill:#73BE2F;}\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#73BE2F;}")), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "IP_ID_38cb",
    width: 12,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "IP_ID_38cb",
    width: 12,
    height: 14
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105429007313894175470000016549998789266748292_",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#IP_ID_38cb",
    style: {
      overflow: "visible"
    },
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105429007313894175470000016549998789266748292_)"
    },
    fill: "#FFFFFF"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.75,4c0-0.4142101-0.3357902-0.75-0.75-0.75S5.25,3.5857899,5.25,4v3.5185199 c0,0.2376399,0.1126199,0.4612203,0.3035798,0.6026702l2,1.4814796c0.33284,0.2465506,0.8025403,0.17659,1.0490899-0.15625 c0.2465506-0.33284,0.17659-0.8025398-0.15625-1.0490894L6.75,7.1407199V4z",
    fill: "#73BE2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6,13c3.3137102,0,6-2.6863003,6-6c0-3.31371-2.6862898-6-6-6S0,3.68629,0,7C0,10.3136997,2.68629,13,6,13z M10.5,7c0,2.48528-2.01472,4.5-4.5,4.5S1.5,9.48528,1.5,7S3.51472,2.5,6,2.5S10.5,4.51472,10.5,7z",
    fill: "#73BE2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTime);
export default __webpack_public_path__ + "static/media/open-time.1b5995a675fc6b432eb30c60967c493b.svg";
export { ForwardRef as ReactComponent };